import { CustomerDbType } from "@ip6m/types";
import { Entity, Column, PrimaryGeneratedColumn } from "typeorm";

@Entity()
export class CustomerDbConfigEntity {

    @PrimaryGeneratedColumn()
    id: number;

    @Column({default: true})
    active: boolean;

    @Column({type: 'enum', enum: CustomerDbType, default: CustomerDbType.default })
    type: CustomerDbType;
}
